import { defineStore, acceptHMRUpdate } from "pinia";

export const useSettingsStore = defineStore("settings", {
  persist: true,
  state: () => ({
    keysMissing: [],
    keysFound: [],
    settings: {}
  }),
  actions: {
    addKey(array, key, value = "") {
      // 💡 - TODO
      // When would this be not done? Non-admins? Production?
      //
      if (!this[array].some((item) => item.key === key)) {
        this[array].push({ key, value });
      }
    },
    addKeyMissing(key) {
      this.addKey("keysMissing", key);
    },
    addKeyFound(key, value) {
      this.addKey("keysFound", key, value);
    }
  }
});

// Used in development to keep the store "hot" during HMR
if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useSettingsStore, import.meta.hot));
}
